import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="bg-gray-900 text-gray-100 p-8 min-h-screen">
      <div className="max-w-4xl mx-auto space-y-8">
        <h1 className="text-3xl font-bold border-b pb-2">Privacy Notice - Traderockfx</h1>
        <p className="text-sm text-gray-400">Last updated: 07 March 2025</p>
        <p>
          Traderockfx (“Traderockfx”, “we”, or “us”) is committed to protecting the
          privacy of our customers, and we take our data protection responsibilities
          with the utmost seriousness.
        </p>
        <p>
          This Privacy Notice describes how Traderockfx collects and processes your
          personal data through our websites and applications. This applies to all
          personal data processing activities across our platforms.
        </p>
        <p>
          This Notice should be read together with our Cookie Notice, which provides
          further details on our use of cookies.
        </p>

        <h1 className="text-3xl font-bold border-b pb-2">Terms of Use</h1>
        <h2 className="text-xl font-semibold mt-4">Client Account</h2>
        <p>
          The client must comply with laws on combating money laundering and terrorist
          financing. They are responsible for maintaining the confidentiality of their
          account and must report unauthorized use immediately.
        </p>
        <p>
          The site reserves the right to terminate services if the client attempts
          unauthorized access or violates platform policies.
        </p>

        <h2 className="text-xl font-semibold mt-4">Funds Deposit and Withdraw</h2>
        <p>
          Funds sent to incorrect details or violating deposit rules are considered
          lost and are not refundable.
        </p>

        <h2 className="text-xl font-semibold mt-4">Site Responsibilities</h2>
        <p>
          The website ensures reasonable measures for security and proper storage of
          customer funds.
        </p>

        <h2 className="text-xl font-semibold mt-4">User Responsibilities</h2>
        <p>
          Clients must use the site legally and responsibly, refrain from illicit
          activities, and stay updated on platform changes.
        </p>

        <h2 className="text-xl font-semibold mt-4">Intellectual Property</h2>
        <p>All intellectual property rights on the site belong to Traderockfx.</p>

        <h2 className="text-xl font-semibold mt-4">Responsibility</h2>
        <p>
          The site is not responsible for any financial losses due to internet outages,
          security vulnerabilities, or blockchain failures.
        </p>

        <h2 className="text-xl font-semibold mt-4">Termination</h2>
        <p>
          The site reserves the right to terminate accounts or modify platform
          services at any time, especially in cases of security breaches or illegal
          activities.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;